import debounce from '../functions/debounce';
import {
  productChange,
  WEDDING_SWITCHER_CLASS,
  CHOICE_DATA_CLASS
} from '../functions/productChange';
import { updateSelectors } from '../functions/productChangeV2';
import { SELECT_FILLED_EVENT, openSelect } from '../functions/select';
import { setListenersFromSelector } from '../functions/listeners';
import { querySelectorAll, querySelector, querySelectorId } from '../functions/querySelectors';
import { ROOT_CLASS } from '../scripts/productGallery';
import {
  BREAKPOINT_MEDIUM,
  BREAKPOINT_LARGE
} from '../config/breakpoints';
import isMobile from '../functions/isMobile';
import alert from '../modules/alert';
import { validateForm } from '../functions/validateForm';
import validateRadios from '../functions/validateRadios';
import {
  INACTIVE_CLASS,
  ACTIVE_CLASS
} from '../functions/setSwitchers';
import {
  RADIO_INPUT_CLASS,
  CHECKBOX_INPUT_CLASS,
  DEFAULT_TRANSITION_TIME,
  U_DN_CLASS
} from '../config/main';
import {
  SELECT_CLASS
} from '../scripts/typo';
import { setFontChecker } from '../functions/fontSelect';

const SWITCHER_INIT_CLASS = 'jrs-init';
const PRODUCT_MAIN_CLASS = 'p-detail-product';
const ADDITIONAL_WRAPPER_CLASS = 'c-product-additional';
const ADDITIONAL_WRAPPER_ACTIVE_CLASS = 'c-product-additional--active';
const ADDITIONAL_WRAPPER_ACTIVE_AFTER_ANIMATION_CLASS = 'c-product-additional--active-after-animation';
const ADDITIONAL_CONTENT_CLASS = 'c-product-additional__content';
const ADDITIONAL_CLASS = 'c-product-additional__toggler';
const ADDITIONAL_INIT_CLASS = 'cpat-init';
const DESCRIPTION_CLASS = 'c-product-intro__header';
const SOLD_OUT_CLASS = 'js-detail-soldout';
const FORM_BUTTON_ID = 'js-package-button';
const FORM_BUTTON_INIT_CLASS = 'jpb-init';
const FORM_ID = 'ProductViewForm';
const FORM_INIT_CLASS = 'pvf-init';
const RADIO_INPUT_INIT_CLASS = 'jpri-init';
const CHECKBOX_INPUT_INIT_CLASS = 'jprc-init';
export const EXPRESS_CHECKBOX_CLASS = 'js-expres-checkbox';
export const EXPRESS_ELEMENT_CLASS = 'js-express-element-class';

let galleryElement = null;
let descriptionElement = null;

let allowSubmitForm = function() {
  let form = querySelectorId(FORM_ID);
  let items = querySelectorAll('input[required]:not([type="radio"]), select[required]', form);
  let radios = querySelectorAll('input[type="radio"][required]', form);
  let allow = true;

  allow = validateForm(items, allow);
  allow = validateRadios(radios, form);

  // pokud je neco za switcher
  let activeSwitchers = querySelectorAll(`.${ACTIVE_CLASS}`, form);

  activeSwitchers.forEach((switcher) => {
    // klasicky inputy
    let items = querySelectorAll('input:not([type="radio"])[data-switcher-required], select[data-switcher-required]', switcher);

    items.forEach((item) => {
      if (!item.closest(`.${INACTIVE_CLASS}`)) {
        if (!validateForm([item])) {
          allow = false;
        }
      }
    });

    // klasicky radio inputy
    let radioItems = querySelectorAll('input[type="radio"][data-switcher-required], select[data-switcher-required]', switcher);

    radioItems.forEach((radioItem) => {
      if (!radioItem.closest(`.${INACTIVE_CLASS}`)) {
        if (!validateRadios([radioItem], form)) {
          allow = false;
        }
      }
    });
  });

  return allow;
};

let formButtonClick = function(event) {
  if (!allowSubmitForm()) {
    event.preventDefault();
    return false;
  }
};

let formSubmit = function(event) {
  if (!allowSubmitForm()) {
    event.preventDefault();
    return false;
  }
};

let setSoldOutModal = function() {
  let soldOutElement = querySelector(`.${SOLD_OUT_CLASS}`);

  if (soldOutElement) {
    alert.open({
      nodeElement: soldOutElement,
      modifs: ['soldModal']
    });
  }
};

let switcherChange = function(event) {
  let items = querySelectorAll(`.${WEDDING_SWITCHER_CLASS}:checked`);

  if (!items.length) {
    event.preventDefault();
    event.stopPropagation();

    this.checked = true;
  }

  productChange();
};

let additionalClick = function(event) {
  event.preventDefault();

  let wrapper = this.closest(`.${ADDITIONAL_WRAPPER_CLASS}`);
  let content = querySelector(`.${ADDITIONAL_CONTENT_CLASS}`, wrapper);

  if (wrapper.classList.contains(ADDITIONAL_WRAPPER_ACTIVE_CLASS)) {
    wrapper.classList.remove(ADDITIONAL_WRAPPER_ACTIVE_CLASS);
    wrapper.classList.remove(ADDITIONAL_WRAPPER_ACTIVE_AFTER_ANIMATION_CLASS);
    content.style.removeProperty('max-height');
  }
  else {
    wrapper.classList.add(ADDITIONAL_WRAPPER_ACTIVE_CLASS);

    setTimeout(() => {
      wrapper.classList.add(ADDITIONAL_WRAPPER_ACTIVE_AFTER_ANIMATION_CLASS);
    }, DEFAULT_TRANSITION_TIME);

    let inner = querySelector(`.${ADDITIONAL_CONTENT_CLASS}-inner`, content);
    content.style.maxHeight = `${inner.getBoundingClientRect().height + 40}px`;
  }
};

let radioInputChange = function(event) {
  productChange(this);
};

let checkboxInputChange = function(event) {
  productChange(this);
};

let setRingSwitcher = function() {
  setListenersFromSelector(
    `.${WEDDING_SWITCHER_CLASS}`,
    SWITCHER_INIT_CLASS,
    switcherChange,
    true,
    'change'
  );
};

let setAdditional = function() {
  setListenersFromSelector(
    `.${ADDITIONAL_CLASS}`,
    ADDITIONAL_INIT_CLASS,
    additionalClick
  );
};

let checkHeightVariables = function() {
  if (!galleryElement) {
    galleryElement = querySelector(`.${ROOT_CLASS}`);
  }

  if (!descriptionElement) {
    descriptionElement = querySelector(`.${DESCRIPTION_CLASS}`);
  }
};

let checkDescriptionHeight = function() {
  if (!isMobile(BREAKPOINT_MEDIUM) && isMobile(BREAKPOINT_LARGE)) {
    checkHeightVariables();

    let descriptionHeight = descriptionElement.getBoundingClientRect().height;
    galleryElement.style.removeProperty('min-height');
    let galleryHeight = galleryElement.getBoundingClientRect().height;

    if (descriptionHeight > galleryHeight) {
      galleryElement.style.minHeight = `${galleryHeight}px`;
    }
  }
};

let setCheckDescriptionHeight = function() {
  checkDescriptionHeight();
  window.addEventListener('resize', debounce(checkDescriptionHeight, 250));
};

let setRequiredItems = function() {
  setListenersFromSelector(
    `#${FORM_BUTTON_ID}`,
    FORM_BUTTON_INIT_CLASS,
    formButtonClick
  );

  setListenersFromSelector(
    `#${FORM_ID}`,
    FORM_INIT_CLASS,
    formSubmit,
    false,
    'submit'
  );
};

let setRadioInputs = function() {
  setListenersFromSelector(
    `.${RADIO_INPUT_CLASS}`,
    RADIO_INPUT_INIT_CLASS,
    radioInputChange,
    'true',
    'change'
  );
};

let setCheckboxesInputs = function() {
  setListenersFromSelector(
    `.${CHECKBOX_INPUT_CLASS}`,
    CHECKBOX_INPUT_INIT_CLASS,
    checkboxInputChange,
    'true',
    'change'
  );
};

let setCheckBeforeSelectOpen = function() {
  if (window.product_choices) { // jde o novy typ change
    let selects = querySelectorAll(`.${CHOICE_DATA_CLASS}`);

    selects.forEach((select) => {
      select.addEventListener(SELECT_FILLED_EVENT, update);
    });
  }
};

let update = function(event) {
  updateSelectors(this);

  setTimeout(() => {
    openSelect(this);
  }, 50);
};

export let setExpress = function(checked, updateEvent = true) {
  let checkboxes = querySelectorAll(`.${EXPRESS_CHECKBOX_CLASS}`);
  let changeItem = null;

  checkboxes.forEach((item) => {
    if (item.getAttribute('type') === 'hidden') {
      item.value = checked ? 1 : 0;
      changeItem = item;
    }
    else {
      item.checked = checked;
    }
  });

  if (updateEvent) {
    productChange(changeItem);
  }
};

export let showExpressOption = function() {
  let elements = querySelectorAll(`.${EXPRESS_ELEMENT_CLASS}`);

  elements.forEach((element) => {
    element.classList.remove(U_DN_CLASS);
  });
};

export let hideExpressOption = function() {
  let elements = querySelectorAll(`.${EXPRESS_ELEMENT_CLASS}`);

  elements.forEach((element) => {
    element.classList.add(U_DN_CLASS);
  });
};

export let setExpressTexts = function() {
/*   let checkboxes = querySelectorAll(`.${EXPRESS_CHECKBOX_CLASS}[type="checkbox"][${EXPRESS_ORIG_TEXT_ATTR}][${EXPRESS_EXPRESS_TEXT_ATTR}]`);

  checkboxes.forEach((item) => {
    let wrapper = item.closest(`.${EXPRESS_TEXT_CHANGE_WRAPPER_CLASS}`);

    if (wrapper) {
      let element = querySelector(`.${EXPRESS_TEXT_CHANGE_ELEMENT_CLASS}`, wrapper);

      if (element) {
        element.textContent = item.getAttribute(item.checked ? EXPRESS_EXPRESS_TEXT_ATTR : EXPRESS_ORIG_TEXT_ATTR);
      }
    }
  }); */
};

let expressChange = function() {
  let changeItem = expressChangeAll(this);

  productChange(changeItem);
  setExpressTexts();
};

export let expressChangeAll = function(clicked) {
  let checkboxes = querySelectorAll(`.${EXPRESS_CHECKBOX_CLASS}`);
  let changeItem = null;

  checkboxes.forEach((item) => {
    if (item.getAttribute('type') === 'hidden') {
      item.value = clicked.checked ? 1 : 0;
      changeItem = item;
    }
    else {
      item.checked = clicked.checked;
    }
  });

  return changeItem;
};

let setExpressCheckboxes = function() {
  setListenersFromSelector(
    `.${EXPRESS_CHECKBOX_CLASS}`,
    `i-${EXPRESS_CHECKBOX_CLASS}`,
    expressChange,
    true,
    'change'
  );
};

export default function() {
  if (querySelector(`.${PRODUCT_MAIN_CLASS}`)) {
    let select = querySelector(`.${SELECT_CLASS}`);

    setRingSwitcher();
    productChange(select || null);
    setAdditional();
    setCheckDescriptionHeight();
    setSoldOutModal();
    setRequiredItems();
    setRadioInputs();
    setCheckboxesInputs();
    setCheckBeforeSelectOpen();
    setExpressCheckboxes();
    setFontChecker();
  }
}
